module.exports = __webpack_public_path__ + "static/media/referidos-logo.c104713c.png";